/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { ExtensionSimpleUser } from '@cp/customer-database-sdk'
import { UserInfo } from '@cp/ic-sdk'

export class BaseUserHelpers {
  static mapUserToFullName = ({ firstName, lastName, userId }: UserInfo): string => {
    return renderFullName({ firstName, lastName, userId })
  }

  static renderFullName = renderFullName
}

// Helper functions.
function renderFullName({ firstName, lastName, userId }: ExtensionSimpleUser): string {
  if (!userId) return '-'

  const result = [firstName, lastName].filter(Boolean).join(' ')
  return result.length > 0 ? result : 'Unnamed user'
}
